import {
    getPost,
    deletePost,
    getDept,
    updatePost,
    savePost,
    saveDept,
    updateDept,
    deleteDept,
    QuerySaleUser,
    QueryAssginRegionList,
    QueryAssginRegionCustomer,
    SaveAssginRegion,
    SaveAssginRegionCustomer,
    QueryCustomerByUser,
    QueryAreaAssgin,
    QueryAreaCustomer,
    QueryAreaRegion,
    QueryIncomeDataAuthority,
    QueryControlTypeCode,
    SaveCustomerControlUser,
    QueryControlUserList,
    QueryRegionTypeCode,
    GetRegionControl,
    QueryUserInventory,
    QueryCustomerByAreaUser,
    SaveAssginCustomer,
    RemoveUserInventogy,
    QueryControlUserAllList
} from '@/request/organization';
import { sortRenderList } from '@/utils/common';
import { QueryUserInventogyArea } from '../../request/organization';
export default {
    namespace: true,
    state: {
        post: {},
        dept: [],
        saleUser: []
    },
    mutations: {
        SET_POST_LIST(state, post) {
            state.post = post;
        },

        SET_DEPT_LIST(state, dept) {
            state.dept = dept;
        },

        SET_SALE_USER(state, saleUser) {
            state.saleUser = saleUser;
        }
    },
    actions: {
        QUERY_POST_LIST: async ({ commit }, payload) => {
            let res = await getPost(payload);
            if (res?.code == 200) {
                commit(
                    'SET_POST_LIST',
                    res.data.sort((a, b) => a.sort - b.sort)
                );
            }
            return res;
        },

        SAVE_POST: async ({ commit }, payload) => {
            let res = await savePost(payload);
            return res;
        },

        UPDATE_POST: async ({}, payload) => {
            let res = await updatePost(payload);
            return res;
        },

        DELETE_POST: async ({}, payload) => {
            let res = await deletePost(payload);
            return res;
        },

        QUERY_DEPT_LIST: async ({ commit }, payload) => {
            let res = await getDept(payload);
            if (res?.code == 200) {
                let list = sortRenderList(res.data, 'sort', 'children');
                commit('SET_DEPT_LIST', [{ deptName: '根目录', deptId: -1 }, ...list]);
            }
            return res;
        },

        SAVE_DEPT: async ({}, payload) => {
            let res = await saveDept(payload);
            return res;
        },

        UPDATE_DEPT: async ({}, payload) => {
            let res = await updateDept(payload);
            return res;
        },

        DELETE_DEPT: async ({}, payload) => {
            let res = await deleteDept(payload);
            return res;
        },

        QUERY_SALE_USER: async ({ commit }, payload) => {
            let res = await QuerySaleUser(payload);
            if (res?.code == 200) {
                commit('SET_SALE_USER', res.data ?? []);
            }
            return res;
        },

        QUERY_REGION_LIST: async ({}, payload) => {
            let res = await QueryRegionList(payload);
            return res;
        },

        QUERY_ASSGIN_REGION_LIST: async ({}, payload) => {
            let res = await QueryAssginRegionList(payload);
            return res;
        },

        QUERY_ASSGIN_REGION_CUSTOMER: async ({}, payload) => {
            let res = await QueryAssginRegionCustomer(payload);
            return res;
        },

        SAVE_ASSGIN_REGION: async ({}, payload) => {
            let res = await SaveAssginRegion(payload);
            return res;
        },

        SAVE_ASSGIN_REGION_CUSTOMER: async ({}, payload) => {
            let res = await SaveAssginRegionCustomer(payload);
            return res;
        },

        QUERY_CUSTOMER_BY_USER: async ({ commit }, payload) => {
            let res = await QueryCustomerByUser(payload);
            return res;
        },

        // 新盘点

        QUERY_AREA_ASSGIN: async ({ commit }, payload) => {
            let res = await QueryAreaAssgin(payload);
            return res;
        },

        QUERY_AREA_CUSTOMER: async ({ commit }, payload) => {
            let res = await QueryAreaCustomer(payload);
            return res;
        },

        QUERY_AREA_REGION: async ({ commit }, payload) => {
            let res = await QueryAreaRegion(payload);
            return res;
        },

        QUERY_INCOME_AUTHORITY: async ({ commit }, payload) => {
            let res = await QueryIncomeDataAuthority(payload);
            return res;
        },

        QUERY_CONTROL_CODE: async ({ commit }, payload) => {
            let res = await QueryControlTypeCode(payload);
            return res;
        },

        SAVE_CUSTOMER_CONTROL_USER: async ({ commit }, payload) => {
            let res = await SaveCustomerControlUser(payload);
            return res;
        },

        QUERY_CONTROL_USER_LIST: async ({ commit }, payload) => {
            let res = await QueryControlUserList(payload);
            return res;
        },

        QUERY_CONTROL_USER_ALL_LIST: async ({ commit }, payload) => {
            let res = await QueryControlUserAllList(payload);
            return res;
        },

        QUERY_REGION_TYPE_CODE: async ({ commit }, payload) => {
            let res = await QueryRegionTypeCode(payload);
            return res;
        },

        GET_REGION_CONTROL: async ({ commit }, payload) => {
            let res = await GetRegionControl(payload);
            return res;
        },

        QUERY_USER_INVENTORY: async ({ commit }, payload) => {
            let res = await QueryUserInventory(payload);
            return res;
        },
        QUERY_CUSTOMER_BY_AREA_USER: async ({ commit }, payload) => {
            let res = await QueryCustomerByAreaUser(payload);
            return res;
        },

        SAVE_ASSGIN_CUSTOMER: async ({ commit }, payload) => {
            let res = await SaveAssginCustomer(payload);
            return res;
        },

        QUERY_USER_INVERTOGY_AREA: async ({ commit }, payload) => {
            let res = await QueryUserInventogyArea(payload);
            return res;
        },
        REMOVE_USER_INVENTOGY: async ({ commit }, payload) => {
            let res = await RemoveUserInventogy(payload);
            return res;
        }
    }
};
